import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBlock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBlock"><Path fillRule="evenodd" clipRule="evenodd" d="M4 3V19H2V21H22V19H20V3H4ZM8 7H11V9H8V7ZM13 7V9H16V7H13ZM8 11H11V13H8V11ZM13 11V13H16V11H13ZM8 15H11V17H8V15ZM13 15V17H16V15H13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBlock;
